var map = {
	"./404": 892,
	"./404.svg": 892,
	"./Vector": 893,
	"./Vector.png": 893,
	"./avatars/profiles/avatar-1": 894,
	"./avatars/profiles/avatar-1.jpg": 894,
	"./avatars/profiles/avatar-2": 895,
	"./avatars/profiles/avatar-2.jpg": 895,
	"./avatars/profiles/avatar-3": 896,
	"./avatars/profiles/avatar-3.jpg": 896,
	"./avatars/profiles/avatar-4": 897,
	"./avatars/profiles/avatar-4.jpg": 897,
	"./avatars/profiles/avatar-5": 898,
	"./avatars/profiles/avatar-5.jpg": 898,
	"./avatars/profiles/avatar-6": 899,
	"./avatars/profiles/avatar-6.jpg": 899,
	"./avatars/profiles/avatar-7": 900,
	"./avatars/profiles/avatar-7.jpg": 900,
	"./avatars/profiles/avatar-8": 901,
	"./avatars/profiles/avatar-8.jpg": 901,
	"./avatars/profiles/standard": 902,
	"./avatars/profiles/standard.jpg": 902,
	"./avatars/profiles/standard1": 903,
	"./avatars/profiles/standard1.jpg": 903,
	"./avatars/projects/project-1": 904,
	"./avatars/projects/project-1.jpg": 904,
	"./avatars/projects/project-2": 905,
	"./avatars/projects/project-2.jpg": 905,
	"./avatars/projects/project-3": 906,
	"./avatars/projects/project-3.jpg": 906,
	"./avatars/projects/project-4": 907,
	"./avatars/projects/project-4.jpg": 907,
	"./avatars/projects/project-5": 908,
	"./avatars/projects/project-5.jpg": 908,
	"./avatars/projects/project-6": 909,
	"./avatars/projects/project-6.jpg": 909,
	"./avatars/projects/project-7": 910,
	"./avatars/projects/project-7.jpg": 910,
	"./avatars/projects/project-8": 911,
	"./avatars/projects/project-8.jpg": 911,
	"./avatars/teams/team-logo-1": 912,
	"./avatars/teams/team-logo-1.jpg": 912,
	"./avatars/teams/team-logo-2": 913,
	"./avatars/teams/team-logo-2.jpg": 913,
	"./avatars/teams/team-logo-3": 914,
	"./avatars/teams/team-logo-3.jpg": 914,
	"./avatars/teams/team-logo-4": 915,
	"./avatars/teams/team-logo-4.jpg": 915,
	"./avatars/teams/team-logo-5": 916,
	"./avatars/teams/team-logo-5.jpg": 916,
	"./avatars/teams/team-logo-6": 917,
	"./avatars/teams/team-logo-6.jpg": 917,
	"./avatars/teams/team-logo-7": 918,
	"./avatars/teams/team-logo-7.jpg": 918,
	"./avatars/teams/team-logo-8": 919,
	"./avatars/teams/team-logo-8.jpg": 919,
	"./basic-logo": 920,
	"./basic-logo.svg": 920,
	"./covers/auth-side-cover": 921,
	"./covers/auth-side-cover.jpg": 921,
	"./covers/header-cover": 922,
	"./covers/header-cover.jpg": 922,
	"./covers/profile-cover-1": 923,
	"./covers/profile-cover-1.jpg": 923,
	"./covers/profile-cover-2": 924,
	"./covers/profile-cover-2.jpg": 924,
	"./covers/profile-cover-3": 925,
	"./covers/profile-cover-3.jpg": 925,
	"./covers/profile-cover-4": 926,
	"./covers/profile-cover-4.jpg": 926,
	"./covers/profile-cover-5": 927,
	"./covers/profile-cover-5.jpg": 927,
	"./covers/profile-cover-6": 928,
	"./covers/profile-cover-6.jpg": 928,
	"./covers/profile-cover-7": 929,
	"./covers/profile-cover-7.jpg": 929,
	"./covers/profile-cover-8": 930,
	"./covers/profile-cover-8.jpg": 930,
	"./covers/sidebar-cover": 931,
	"./covers/sidebar-cover.jpg": 931,
	"./covers/team-cover": 932,
	"./covers/team-cover.jpg": 932,
	"./files/file-1": 933,
	"./files/file-1.jpg": 933,
	"./files/file-2": 934,
	"./files/file-2.jpg": 934,
	"./files/file-3": 935,
	"./files/file-3.jpg": 935,
	"./files/file-4": 936,
	"./files/file-4.jpg": 936,
	"./illustrations/bot-face": 937,
	"./illustrations/bot-face.svg": 937,
	"./illustrations/check": 938,
	"./illustrations/check.svg": 938,
	"./illustrations/check@1.5x": 939,
	"./illustrations/check@1.5x.svg": 939,
	"./illustrations/clock": 940,
	"./illustrations/clock.svg": 940,
	"./illustrations/coworking": 941,
	"./illustrations/coworking.svg": 941,
	"./illustrations/cross@1.5x": 942,
	"./illustrations/cross@1.5x.svg": 942,
	"./illustrations/designer-life": 943,
	"./illustrations/designer-life.svg": 943,
	"./illustrations/error": 944,
	"./illustrations/error.svg": 944,
	"./illustrations/esr-check": 945,
	"./illustrations/esr-check.svg": 945,
	"./illustrations/esr-warning": 946,
	"./illustrations/esr-warning.svg": 946,
	"./illustrations/eye-shape": 947,
	"./illustrations/eye-shape-dark": 948,
	"./illustrations/eye-shape-dark.svg": 948,
	"./illustrations/eye-shape.svg": 947,
	"./illustrations/female": 949,
	"./illustrations/female.svg": 949,
	"./illustrations/happiness": 950,
	"./illustrations/happiness.svg": 950,
	"./illustrations/heart-line": 951,
	"./illustrations/heart-line.png": 951,
	"./illustrations/icon-loader": 952,
	"./illustrations/icon-loader.svg": 952,
	"./illustrations/icons/action-arrow-up": 953,
	"./illustrations/icons/action-arrow-up.svg": 953,
	"./illustrations/icons/action-assign-agency": 783,
	"./illustrations/icons/action-assign-agency.svg": 783,
	"./illustrations/icons/action-assign-locum": 784,
	"./illustrations/icons/action-assign-locum.svg": 784,
	"./illustrations/icons/action-bar-flag": 954,
	"./illustrations/icons/action-bar-flag.svg": 954,
	"./illustrations/icons/action-cancel": 785,
	"./illustrations/icons/action-cancel.svg": 785,
	"./illustrations/icons/action-delete": 955,
	"./illustrations/icons/action-delete.svg": 955,
	"./illustrations/icons/action-payments": 956,
	"./illustrations/icons/action-payments.svg": 956,
	"./illustrations/icons/action-recalculate": 957,
	"./illustrations/icons/action-recalculate.svg": 957,
	"./illustrations/icons/action-recall-agency": 958,
	"./illustrations/icons/action-recall-agency.svg": 958,
	"./illustrations/icons/action-send-agency": 959,
	"./illustrations/icons/action-send-agency.svg": 959,
	"./illustrations/icons/action-sign-off": 960,
	"./illustrations/icons/action-sign-off.svg": 960,
	"./illustrations/icons/action-undo-approval": 961,
	"./illustrations/icons/action-undo-approval.svg": 961,
	"./illustrations/icons/action-undo-signoff": 962,
	"./illustrations/icons/action-undo-signoff.svg": 962,
	"./illustrations/icons/action-unwatch": 786,
	"./illustrations/icons/action-unwatch.svg": 786,
	"./illustrations/icons/action-view-shift": 506,
	"./illustrations/icons/action-view-shift.svg": 506,
	"./illustrations/icons/action-watch": 787,
	"./illustrations/icons/action-watch.svg": 787,
	"./illustrations/icons/applications-date": 963,
	"./illustrations/icons/applications-date.svg": 963,
	"./illustrations/icons/applications-department": 964,
	"./illustrations/icons/applications-department.svg": 964,
	"./illustrations/icons/applications-dropdown-accept": 965,
	"./illustrations/icons/applications-dropdown-accept.svg": 965,
	"./illustrations/icons/applications-dropdown-export": 966,
	"./illustrations/icons/applications-dropdown-export.svg": 966,
	"./illustrations/icons/applications-dropdown-move": 967,
	"./illustrations/icons/applications-dropdown-move-left": 968,
	"./illustrations/icons/applications-dropdown-move-left.svg": 968,
	"./illustrations/icons/applications-dropdown-move-right": 969,
	"./illustrations/icons/applications-dropdown-move-right.svg": 969,
	"./illustrations/icons/applications-dropdown-move.svg": 967,
	"./illustrations/icons/applications-dropdown-note": 970,
	"./illustrations/icons/applications-dropdown-note.svg": 970,
	"./illustrations/icons/applications-dropdown-reject": 971,
	"./illustrations/icons/applications-dropdown-reject.svg": 971,
	"./illustrations/icons/applications-dropdown-review": 972,
	"./illustrations/icons/applications-dropdown-review.svg": 972,
	"./illustrations/icons/applications-gender-female": 973,
	"./illustrations/icons/applications-gender-female.svg": 973,
	"./illustrations/icons/applications-gender-male": 974,
	"./illustrations/icons/applications-gender-male.svg": 974,
	"./illustrations/icons/applications-menu": 975,
	"./illustrations/icons/applications-menu.svg": 975,
	"./illustrations/icons/applications-speciality": 976,
	"./illustrations/icons/applications-speciality.svg": 976,
	"./illustrations/icons/badge-agency": 977,
	"./illustrations/icons/badge-agency-locked": 978,
	"./illustrations/icons/badge-agency-locked.svg": 978,
	"./illustrations/icons/badge-agency.svg": 977,
	"./illustrations/icons/badge-bank": 979,
	"./illustrations/icons/badge-bank.svg": 979,
	"./illustrations/icons/badge-collab-bank": 980,
	"./illustrations/icons/badge-collab-bank.svg": 980,
	"./illustrations/icons/bot-face-locked": 981,
	"./illustrations/icons/bot-face-locked.svg": 981,
	"./illustrations/icons/close": 982,
	"./illustrations/icons/close.svg": 982,
	"./illustrations/icons/esr-chevron": 983,
	"./illustrations/icons/esr-chevron.svg": 983,
	"./illustrations/icons/esr-warning": 984,
	"./illustrations/icons/esr-warning.svg": 984,
	"./illustrations/icons/filter-add": 985,
	"./illustrations/icons/filter-add.svg": 985,
	"./illustrations/icons/filter-export": 986,
	"./illustrations/icons/filter-export.svg": 986,
	"./illustrations/icons/filter-shifts": 987,
	"./illustrations/icons/filter-shifts.svg": 987,
	"./illustrations/icons/mail-button": 988,
	"./illustrations/icons/mail-button.svg": 988,
	"./illustrations/icons/modal-close": 989,
	"./illustrations/icons/modal-close.svg": 989,
	"./illustrations/icons/nav-to-do": 990,
	"./illustrations/icons/nav-to-do.svg": 990,
	"./illustrations/icons/navigation-arrow": 991,
	"./illustrations/icons/navigation-arrow.svg": 991,
	"./illustrations/icons/notifications-active": 992,
	"./illustrations/icons/notifications-active.svg": 992,
	"./illustrations/icons/notifications-inactive": 993,
	"./illustrations/icons/notifications-inactive.svg": 993,
	"./illustrations/icons/pay-per-item": 994,
	"./illustrations/icons/pay-per-item.svg": 994,
	"./illustrations/icons/shift-blocks": 995,
	"./illustrations/icons/shift-blocks-blue": 996,
	"./illustrations/icons/shift-blocks-blue.svg": 996,
	"./illustrations/icons/shift-blocks.svg": 995,
	"./illustrations/icons/shift-booking": 997,
	"./illustrations/icons/shift-booking.svg": 997,
	"./illustrations/icons/shift-clinical": 998,
	"./illustrations/icons/shift-clinical.svg": 998,
	"./illustrations/icons/shift-cost": 999,
	"./illustrations/icons/shift-cost.svg": 999,
	"./illustrations/icons/shift-info": 1000,
	"./illustrations/icons/shift-info.svg": 1000,
	"./illustrations/icons/shift-note": 1001,
	"./illustrations/icons/shift-note.svg": 1001,
	"./illustrations/icons/shift-site": 1002,
	"./illustrations/icons/shift-site.svg": 1002,
	"./illustrations/icons/shift-time": 1003,
	"./illustrations/icons/shift-time.svg": 1003,
	"./illustrations/icons/shift-type": 1004,
	"./illustrations/icons/shift-type-agency-cascade-awaiting": 1005,
	"./illustrations/icons/shift-type-agency-cascade-awaiting.svg": 1005,
	"./illustrations/icons/shift-type-agency-cascade-override": 1006,
	"./illustrations/icons/shift-type-agency-cascade-override.svg": 1006,
	"./illustrations/icons/shift-type-agency-cascade-sent": 1007,
	"./illustrations/icons/shift-type-agency-cascade-sent.svg": 1007,
	"./illustrations/icons/shift-type-agency-filled": 1008,
	"./illustrations/icons/shift-type-agency-filled.svg": 1008,
	"./illustrations/icons/shift-type-agency-locked": 1009,
	"./illustrations/icons/shift-type-agency-locked.svg": 1009,
	"./illustrations/icons/shift-type-agency-sent": 1010,
	"./illustrations/icons/shift-type-agency-sent.svg": 1010,
	"./illustrations/icons/shift-type-bank": 1011,
	"./illustrations/icons/shift-type-bank.svg": 1011,
	"./illustrations/icons/shift-type-collab-bank": 1012,
	"./illustrations/icons/shift-type-collab-bank.svg": 1012,
	"./illustrations/icons/shift-type-on-call": 1013,
	"./illustrations/icons/shift-type-on-call.svg": 1013,
	"./illustrations/icons/shift-type-roster-blue": 1014,
	"./illustrations/icons/shift-type-roster-blue.svg": 1014,
	"./illustrations/icons/shift-type-roster-shift": 1015,
	"./illustrations/icons/shift-type-roster-shift.svg": 1015,
	"./illustrations/icons/shift-type-rostering": 1016,
	"./illustrations/icons/shift-type-rostering.svg": 1016,
	"./illustrations/icons/shift-type.svg": 1004,
	"./illustrations/icons/table-ammended-timesheet": 1017,
	"./illustrations/icons/table-ammended-timesheet.svg": 1017,
	"./illustrations/icons/table-escalation-alert": 1018,
	"./illustrations/icons/table-escalation-alert.svg": 1018,
	"./illustrations/icons/table-escalation-arrow": 1019,
	"./illustrations/icons/table-escalation-arrow.svg": 1019,
	"./illustrations/icons/table-escalation-exclamation": 1020,
	"./illustrations/icons/table-escalation-exclamation.svg": 1020,
	"./illustrations/lost": 1021,
	"./illustrations/lost.svg": 1021,
	"./illustrations/male": 1022,
	"./illustrations/male.svg": 1022,
	"./illustrations/meditate": 1023,
	"./illustrations/meditate.svg": 1023,
	"./illustrations/minus": 1024,
	"./illustrations/minus.svg": 1024,
	"./illustrations/minus@1.5x": 1025,
	"./illustrations/minus@1.5x.svg": 1025,
	"./illustrations/oval": 1026,
	"./illustrations/oval.svg": 1026,
	"./illustrations/pencil": 1027,
	"./illustrations/pencil.svg": 1027,
	"./illustrations/pie": 1028,
	"./illustrations/pie.svg": 1028,
	"./illustrations/plus": 1029,
	"./illustrations/plus.svg": 1029,
	"./illustrations/plus@1.5x": 1030,
	"./illustrations/plus@1.5x.svg": 1030,
	"./illustrations/proposals": 1031,
	"./illustrations/proposals.svg": 1031,
	"./illustrations/quote-sign": 1032,
	"./illustrations/quote-sign-dark": 1033,
	"./illustrations/quote-sign-dark.svg": 1033,
	"./illustrations/quote-sign.svg": 1032,
	"./illustrations/scale": 1034,
	"./illustrations/scale.svg": 1034,
	"./illustrations/star": 1035,
	"./illustrations/star.svg": 1035,
	"./illustrations/sticky": 1036,
	"./illustrations/sticky.svg": 1036,
	"./illustrations/wallet": 1037,
	"./illustrations/wallet.svg": 1037,
	"./logo": 1038,
	"./logo-agency": 1039,
	"./logo-agency.svg": 1039,
	"./logo-emblem": 1040,
	"./logo-emblem.png": 1040,
	"./logo-hub": 1041,
	"./logo-hub.svg": 1041,
	"./logo.svg": 1038,
	"./masks/avatar-group": 1042,
	"./masks/avatar-group-hover": 1043,
	"./masks/avatar-group-hover-last": 1044,
	"./masks/avatar-group-hover-last.svg": 1044,
	"./masks/avatar-group-hover.svg": 1043,
	"./masks/avatar-group.svg": 1042,
	"./masks/avatar-status": 1045,
	"./masks/avatar-status.svg": 1045,
	"./masks/icon-status": 1046,
	"./masks/icon-status.svg": 1046,
	"./masks/sad-face": 1047,
	"./masks/sad-face.svg": 1047,
	"./patchwork-icon": 1048,
	"./patchwork-icon.png": 1048,
	"./posts/post-1": 1049,
	"./posts/post-1.jpg": 1049,
	"./timesheet_authorisers/reset-pin-lock": 1050,
	"./timesheet_authorisers/reset-pin-lock.svg": 1050,
	"./trauma": 1051,
	"./trauma.png": 1051
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1483;